import {Component, EventEmitter, OnInit, OnDestroy, HostListener} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import { SessionServiceService } from './services/session-service.service';
import { LoggerService } from "./services/logger/logger.service";
import { MatDialog } from '@angular/material/dialog';
import { DialogStartVideoComponent } from './dialog-start-video/dialog-start-video.component';
import { DialogStartTextComponent } from './dialog-start-text/dialog-start-text.component';
import { ChatHistoryService } from './services/chat-history.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy  {
  constructor(
    private _logger: LoggerService,
    private dialog: MatDialog,
    private chatHistoryService: ChatHistoryService
  ) {
  }

  // handle logging when the app/tab/window is closed
  @HostListener('window:beforeunload', [ '$event' ])
  ngOnDestroy() {
    this._logger.handleOnDestroy();
  }

  // Listen for page refresh/close to clear session storage
  @HostListener('window:beforeunload', ['$event'])
  clearSessionOnRefresh(event: Event) {
    // Clear all chat histories when the page is refreshed
    this.chatHistoryService.clearAllChatHistories();
  }

  openVideoDialog() {
    const dialogRef = this.dialog.open(DialogStartVideoComponent, {
      width: '800px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Handle the dialog result
        console.log('Video dialog result:', result);
      }
    });
  }

  openTextDialog() {
    const dialogRef = this.dialog.open(DialogStartTextComponent, {
      width: '800px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Handle the dialog result
        console.log('Text dialog result:', result);
      }
    });
  }
}

export function hasObservers(observable: Subject<any> | EventEmitter<any>): boolean {
  return observable.observers.length > 0;
}
